<div class="flex items-center">
    <button class="btn-sm bg-[#3fb4b5] text-white" type="button" (click)="trigger(value)">
        <mat-icon>search</mat-icon>
    </button>
</div>